import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/move-to-top/move-to-top.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/sub-categories/sub-categories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/sub-header/sub-header.tsx");
